import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from "@angular/core";
import { NgClass } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-state-displayer-status",
  templateUrl: "./state-displayer-status.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./state-displayer-status.component.scss"],
  imports: [NgClass, TranslateModule]
})
export class StateDisplayerStatusComponent implements OnInit {
  @Input() statusDescription: string;
  @Input() statusDays: number;
  @Input() statusColor: string;

  public isStatusDescriptionKey: boolean = false;

  constructor() {}

  ngOnInit(): void {
    if (
      ["ok", "transit", "alert", "tear-off", "static", "quiet"].includes(
        this.statusDescription
      )
    ) {
      this.isStatusDescriptionKey = true;
    }
  }

  public getStatusDescriptionKey(): string {
    if (
      this.statusDescription === "OK" ||
      this.statusDescription === "tear-off"
    ) {
      return this.statusDescription.toLowerCase();
    } else if (this.statusDescription === "IN TRANSIT") {
      return "transit";
    } else if (this.statusDescription.includes("ALERT")) {
      return "alert";
    } else if (this.statusDescription.includes("static")) {
      return "static";
    } else if (this.statusDescription.includes("Quiet")) {
      return "quiet";
    }
    return "partialData";
  }

  public isDayDisplayable(): boolean {
    return (
      this.statusDays &&
      this.statusDescription !== "transit" &&
      this.statusDescription !== "IN TRANSIT" &&
      this.statusDescription !== "ok" &&
      this.statusDescription !== "OK"
    );
  }
}
